
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import SwiperContainer from '../Containers/SwiperContainer.vue'
import AppLazyImage from '~/components/UI/AppLazyImage.vue'
import PageContainer from '~/components/Containers/PageContainer.vue'
import { ContainerOptions } from '~/model'
@Component({
  components: {
    PageContainer,
    SwiperContainer,
    AppLazyImage
  }
})
export default class extends Vue {
  @Prop({
    default: () => {}
  })
  readonly containerOptions!: ContainerOptions

  @Prop({
    default: () => []
  })
  readonly slides!: any[]

  @Prop({
    default: false
  })
  readonly isAlter!: boolean

  sliderOptions = {
    loop: this.slides.length > 1,
    preloadImages: false,
    lazy: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 10,
    navigationId: 'info-c',
    pagination: true
  }
}
